import { render, staticRenderFns } from "./page-meditation.vue?vue&type=template&id=54cd5aec"
import script from "./page-meditation.vue?vue&type=script&lang=ts"
export * from "./page-meditation.vue?vue&type=script&lang=ts"
import style0 from "./page-meditation.vue?vue&type=style&index=0&id=54cd5aec&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports